export const base = 'audience-connection';

// export const getAllPersonas = `${base}`;
// export const getTopPersonas = `${base}/top-personas`;
// export const getPersonaById = `${base}`;
export const postConnection = `${base}`;
export const getConnections = `${base}`;
